module.exports = __webpack_public_path__ + "img/star_2_5.acc6fbbc.png";